export enum EnumTipoDeDocumento {
    CPF = 'CPF',
    CNPJ = 'CNPJ'
}



// WEBPACK FOOTER //
// ./src/app/resources/enum/enumTipoDeDocumento.ts